import React from 'react';
import classNames from 'classnames';
import MobileNavbar from './MobileNavbar';
import { TourStepPrefix, WorkflowId } from '../../core/Enums';
import { useTour } from '../../core/TourProvider';
import styles from '../../stylesheets/managerLayout.module.scss';

interface ManagerLayoutProps {
  children: React.ReactNode;
}

const ManagerLayout = ({ children }: ManagerLayoutProps) => {
  const { tour, stepId } = useTour();
  const showMaintenanceNavbar =
    tour.id === WorkflowId.MAINTENANCE &&
    stepId.startsWith(TourStepPrefix.MANAGER);

  if (!showMaintenanceNavbar) {
    return (
      <div
        className={classNames(
          styles.managerLayout,
          styles.managerLayoutWithoutNavbar
        )}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={classNames(
        styles.managerLayout,
        styles.managerLayoutWithNavbar
      )}
    >
      <MobileNavbar />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default ManagerLayout;
